import { makeObservable, computed } from 'mobx'
import WorkspacePostingOpportunity from './WorkspacePostingOpportunity'

export default class WorkspacePostingOpportunityViewModel {
  constructor(
    private isDisabled: () => boolean,
    public opportunity: WorkspacePostingOpportunity
  ) {
    makeObservable(this, {
      opportunityId: computed,
      disabled: computed,
    })
  }

  /**
   * The ID of the opportunity.
   */
  get opportunityId() {
    return this.opportunity.id
  }

  /**
   * Whether selection is disabled.
   */
  get disabled() {
    return this.isDisabled()
  }
}
